import input from "./input";
import button from "./button";
import table from "./table";
import label from "./label";
import error from "./error";
import target from "./target";
import object from "./object";
import messages from "./messages";
import enumT from "./enum";
import modal from "./modal";
import success from "./success";
import alert from "./alert";
import titleRoute from "./titleRoute";
import placeholder from "./placeholder";
import option from "./option";

const german = {
    title: 'Octopus',
    button,
    input,
    table,
    label,
    error,
    'error.': 'Ein Fehler ist aufgetreten',
    target,
    messages,
    object,
    enumT,
    modal,
    success,
    'success.': 'Aktion erfolgreich',
    alert,
    titleRoute,
    placeholder,
    option
}

//Comment in if you want to translate to different languages
// console.log('german', JSON.stringify(german))

export default german;
